import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';
import {validateFile} from '../../helpers/Fields';
import * as Config from '../../config/Config';
const $=window.$;


export default class SupportDesk extends Component {

	 constructor(props) {


        super(props);

        this.state={
            doyou : [],
            count : 0,
            noticecount : 0,
        };


    }
  

 

	sendSupportQuery() {
		  let formData = new FormData();
		  formData.append("user_id", User.UserId());
		  formData.append("subject", this.refs.subject.value);
		  formData.append("query", this.refs.query.value);
			if (this.refs.attachment.files[0] != undefined) {
				formData.append("attachment", this.refs.attachment.files[0]);
			}

		  Common.reactLoader("show", "Please wait...");
		  fetch(Config.domainUrl +"user/supportdesk/query", {
		    method: "POST",
		    headers: {
		      'Accept': 'application/json',
          'Authorization':'Bearer ' +Common.getTokenData()
		    },
		    body: formData
		  }).then((response) => response.json()).then((responseJson) => {
		    Common.reactLoader("hide");
		    if (responseJson.status == 0) {
		      Common.message(responseJson.message, responseJson.errors, "error");
		    } else {
          Common.message("", responseJson.message, "success");
          $('form#qtechsupport')[0].reset();
          Common.leftClose();
		    }
		  });
		}

	componentDidMount() {
      
	}

  render() {
  	let corporateID = Common.getUserData('corporateID', true);
  	const {Webview} = this.props;
    return (
			<aside className="slide-out support">
					
					{(Webview===undefined && Webview!=='webview' && corporateID!=77) && 
					<a className="support-ico" href="javascript:void(0);" title="Support Desk" id="supportd"></a>}
					<form action="#" id="qtechsupport"  method="POST" encType="multipart/form-data">
							<h2><img src={'images/support-ico2.png'} align="texttop" alt="" border="0" /> Support Desk</h2>
							<p>For technical queries and clarifications about the program.</p>
							<input ref="subject" id='jquerysubject' type="text" placeholder="Subject" />
							<textarea ref="query" id='jqueryquery' placeholder="Query"></textarea>
							<input ref="attachment" type="file" id='jqueryfile' style={{border: "none"}} data-valid-types="jpg,jpeg,png,gif" data-max-limit="2097152" onChange={(e)=>validateFile(e)} />
							<span className="smalltextreg">Maximum upload size is 2MB. (Only JPEG, GIF Formats)</span>
							<input type="button" value="Send" onClick={()=>this.sendSupportQuery()} />
					</form>
			</aside>
    );
  }
}



// WEBPACK FOOTER //
// ./src/partials/qlink_partials/SupportDesk.js